import { useCallback, useEffect } from 'react'
import { useApolloClient, useReactiveVar } from '@apollo/client'
import { guestSessionIdVar } from '../store'
import { ensureGuestSession } from '../utils/ensure-guest-session'

/**
 * Makes sure the visitor has a guest session while `enabled`; `ready` once
 * its id is known. The session is shared page-wide (`ensureGuestSession`), so
 * every caller waits for the same request.
 */
export const useEnsureGuestSession = (enabled: boolean) => {
  const client = useApolloClient()
  const id = useReactiveVar(guestSessionIdVar)

  const ensure = useCallback(() => ensureGuestSession(client), [client])

  useEffect(() => {
    if (!enabled) return

    void ensure()
  }, [enabled, ensure])

  return { ready: id !== null, ensure }
}
